var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_1798)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 5.075C3.75 4.34321 4.34321 3.75 5.075 3.75H18.924C19.657 3.75 20.25 4.34345 20.25 5.075V14.9244C20.2501 15.0984 20.2159 15.2708 20.1493 15.4316C20.0828 15.5924 19.9852 15.7386 19.8621 15.8617C19.7391 15.9848 19.593 16.0825 19.4322 16.1491C19.2714 16.2157 19.0991 16.25 18.925 16.25H15.0171C15.0061 16.2498 14.9951 16.2498 14.984 16.25H9.01594C9.0049 16.2498 8.99389 16.2498 8.98291 16.25H5.075C4.72359 16.25 4.38657 16.1104 4.13808 15.8619C3.8896 15.6134 3.75 15.2764 3.75 14.925V5.075ZM8.03941 17.75H5.075C4.32576 17.75 3.60721 17.4524 3.07742 16.9226C2.54763 16.3928 2.25 15.6742 2.25 14.925V5.075C2.25 3.51479 3.51479 2.25 5.075 2.25H18.924C20.485 2.25 21.75 3.51455 21.75 5.075V14.9236C21.7501 15.2946 21.6772 15.6623 21.5354 16.0051C21.3935 16.348 21.1854 16.6596 20.9231 16.9221C20.6607 17.1846 20.3492 17.3928 20.0064 17.5348C19.6636 17.6769 19.2961 17.75 18.925 17.75H15.9606L16.7276 20.8181C16.8281 21.2199 16.5837 21.6271 16.1819 21.7276C15.7801 21.8281 15.3728 21.5837 15.2724 21.1819L14.4144 17.75H9.58558L8.7276 21.1819C8.62714 21.5837 8.21994 21.8281 7.81809 21.7276C7.41625 21.6271 7.17193 21.2199 7.27239 20.8181L8.03941 17.75Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 7C11.25 6.58579 10.9142 6.25 10.5 6.25C10.0858 6.25 9.75 6.58579 9.75 7V13C9.75 13.4142 10.0858 13.75 10.5 13.75C10.9142 13.75 11.25 13.4142 11.25 13V7ZM8.25 10.27C8.25 9.85581 7.91421 9.52002 7.5 9.52002C7.08579 9.52002 6.75 9.85581 6.75 10.27V13C6.75 13.4142 7.08579 13.75 7.5 13.75C7.91421 13.75 8.25 13.4142 8.25 13V10.27ZM13.5 8.92999C13.9142 8.92999 14.25 9.26578 14.25 9.67999V13C14.25 13.4142 13.9142 13.75 13.5 13.75C13.0858 13.75 12.75 13.4142 12.75 13V9.67999C12.75 9.26578 13.0858 8.92999 13.5 8.92999ZM17.25 7.54999C17.25 7.13577 16.9142 6.79999 16.5 6.79999C16.0858 6.79999 15.75 7.13577 15.75 7.54999V13C15.75 13.4142 16.0858 13.75 16.5 13.75C16.9142 13.75 17.25 13.4142 17.25 13V7.54999Z",
    fill: "#8F8F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_1798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.67cc2f2577ca2593529247e733675543.svg";
export { ForwardRef as ReactComponent };